import { acpPostHandOffToAcitvateRegisterStates } from './states';

export default (appModule) => {
  appModule.config(acpPostHandOffToAcitvateRegisterStates);
};
